import * as swcHelpers from '@swc/helpers';
import { StringUtils, formatHour } from '@grandvisionhq/utils';

function formatTime(time) {
    return typeof time === 'number' ? formatHour(time) : time;
}
const isStoreWithDeprecatedFields = (store)=>// properties are all optional so we need to check all of them
    'mondayOpenClose' in store || 'tuesdayOpenClose' in store || 'wednesdayOpenClose' in store || 'thursdayOpenClose' in store || 'fridayOpenClose' in store || 'saturdayOpenClose' in store || 'sundayOpenClose' in store
;
const getOpeningHours = (store)=>{
    var _openingHours;
    const storeOpeningHours = isStoreWithDeprecatedFields(store) ? swcHelpers.objectSpread({}, (_openingHours = store.openingHours) !== null && _openingHours !== void 0 ? _openingHours : {
        monday: store.mondayOpenClose,
        tuesday: store.tuesdayOpenClose,
        wednesday: store.wednesdayOpenClose,
        thursday: store.thursdayOpenClose,
        friday: store.fridayOpenClose,
        saturday: store.saturdayOpenClose,
        sunday: store.sundayOpenClose
    }) : swcHelpers.objectSpread({}, store.openingHours);
    return Object.entries(storeOpeningHours).filter(([, hours])=>hours && hours.length
    ).map(([day, hours])=>{
        const dayOfWeek = `https://schema.org/${StringUtils.upFirst(day)}`;
        return hours.map(({ open , close  })=>({
                '@type': 'OpeningHoursSpecification',
                closes: formatTime(close),
                dayOfWeek,
                opens: formatTime(open)
            })
        );
    }).flat();
};

export { getOpeningHours };
//# sourceMappingURL=get-opening-hours.js.map
